import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { HomeOutlined, ShareAltOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, Outlet } from "react-router-dom";

const DiffCheckerSetup = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedKey, setSelectedKey] = useState("Home");

    // Sync active menu item with URL
    useEffect(() => {
        if (location.pathname.includes("/connections")) {
            setSelectedKey("connections"); // match key in Menu
        } else {
            setSelectedKey("Home");
        }
    }, [location.pathname]);

    const handleMenuClick = ({ key }) => {
        setSelectedKey(key);
        if (key === "Home") {
            navigate("/diffinsight/home");
        } else if (key === "connections") {
            navigate("/diffinsight/connections");
        }
    };

    return (
        <div style={{ marginTop: 0, padding: 0 }}>
            <div style={{ background: "#fff", padding: 0, marginTop: 0 }}>
                <Menu
                    mode="horizontal"
                    selectedKeys={[selectedKey]}
                    onClick={handleMenuClick}
                    style={{ borderBottom: "1px solid #f0f0f0" }}
                >
                    <Menu.Item key="Home" icon={<HomeOutlined />}>
                        Home
                    </Menu.Item>
                    <Menu.Item key="connections" icon={<ShareAltOutlined />}>
                        Connections
                    </Menu.Item>
                </Menu>
            </div>

            {/* Use Outlet to render child routes */}
            <div style={{ marginTop: 0 }}>
                <Outlet />
            </div>
        </div>
    );
};

export default DiffCheckerSetup;
